(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-product-root]').forEach(root => {
      const sticky = [...document.querySelectorAll('[data-sticky-atc]')].find(form => form.dataset.productInstance === root.dataset.productInstance);
      if (!sticky || sticky.dataset.selectorsReady) return;
      sticky.dataset.selectorsReady = 'true';
      const pack = sticky.querySelector('[data-sticky-pack]');
      const measure = sticky.querySelector('[data-sticky-measure]');
      const flavour = sticky.querySelector('[data-sticky-flavour]');
      const title = sticky.querySelector('[data-sticky-variant-title]');
      const cards = [...root.querySelectorAll('[data-variant-card]')];
      const sync = () => {
        const id = root.querySelector('[data-variant-input]')?.value;
        const selected = cards.find(card => card.dataset.variantId === id);
        if (pack) {
          [...pack.options].forEach(option => {
            const card = cards.find(item => item.dataset.variantId === option.value);
            if (!card) return;
            option.textContent = card.querySelector('.iurop-variant__pack')?.textContent.trim() || card.dataset.variantTitle;
            option.hidden = card.hidden && option.value !== id;
            option.disabled = card.dataset.variantAvailable !== 'true';
          });
          pack.value = id;
        }
        if (title && selected) title.textContent = selected.querySelector('.iurop-variant__pack')?.textContent.trim() || selected.dataset.variantTitle;
        const status = sticky.querySelector('[data-sticky-status]');
        if (status) status.textContent = '';
      };
      pack?.addEventListener('change', () => {
        const radio = cards.find(card => card.dataset.variantId === pack.value)?.querySelector('input[type="radio"]');
        if (radio && !radio.disabled) {
          radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        } else sync();
      });
      measure?.addEventListener('change', () => {
        const choice = [...root.querySelectorAll('[data-measure-link]')].find(link => link.textContent.trim() === `${measure.value} ml`);
        if (choice) choice.click();
        measure.value = measure.querySelector('option[selected]')?.value || measure.value;
      });
      if (flavour) {
        const choices = [...root.querySelectorAll('.iurop-product__flavour-option')];
        flavour.replaceChildren(...choices.map((choice, index) => {
          const option = new Option(choice.textContent.trim(), String(index));
          option.selected = choice.classList.contains('is-active');
          option.disabled = !choice.hasAttribute('href') && !option.selected;
          return option;
        }));
        flavour.addEventListener('change', () => {
          const choice = choices[Number(flavour.value)];
          if (!choice?.hasAttribute('href')) return;
          const url = new URL(choice.href, location.origin);
          const preview = new URL(location.href).searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          location.assign(url.href);
        });
      }
      root.addEventListener('iurop:variant-change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
